<template>
  <Dialog
    v-model="dialogDeleteActor"
    icon="fas fa-trash-alt"
    :title="'削除'"
    textNo="いいえ"
    textYes="はい"
    colorTextYes="red--text"
  >
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn color @click="dialogDeleteActor = false" small>キャンセル</v-btn>
      <v-btn
        color="error"
        @click="handleDeleteActor(item.Id)"
        small
        :loading="loading"
        :disabled="loading"
        >OK</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import { deleteActor } from "@/api/Actor.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialogDeleteActor: false,
      loading: false,
    };
  },
  methods: {
    async handleDeleteActor() {
      this.loading = true;
      let params = {
        id: this.item.Id,
        conversation_id: this.$route.params.skit,
      };
      await deleteActor(params)
        .then(() => {
          this.$emit("resetList");
          this.dialogDeleteActor = false;
        })
        .catch((this.loading = false));
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>